import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { routeEquals } from './helpers/route.helpers';
import { StateService } from '@app/services/state/state.service';

@Injectable()
export class AppResolve  {
  constructor(private state: StateService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    return routeEquals(() => this.state.inProgress(), state, route);
  }
}
